import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import DriverTabData from './DriverTab';

interface DriverIncidentReport {
    loading: boolean;
    errors: any;
    vehicles: GenericList[];
    truckId: number;
}

interface GenericList {
    id: number;
    name: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class DriverIncidentReportData extends React.Component<RouteComponentProps<{}>, DriverIncidentReport> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            errors: {},
            vehicles: [],
            truckId: 0
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        //see if there is a truck set
        let userParams: INameToValueMap = {};
        userParams["truckId"] = -1;
        userParams = this.props.match.params;
        let truckId = userParams["truckId"];
        if (!truckId) { truckId = -1; }

        //they have to select a truck before they can complete the truck checklist
        this.getData(truckId);
    }

    async getData(truckId: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Job/GetTrucks?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            let vehicles: GenericList[] = res.data;

            this.setState({ vehicles: vehicles, truckId: truckId, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    back = (e: any) => {
        e.preventDefault();
        this.props.history.push("/driverjobs");
    }

    handleTruckChange = (e: any) => {
        //get check list for new truck

    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var driverTabsMobile = <DriverTabData tab="driverjobs" truckId={this.state.truckId} />
        let vehicles = this.state.vehicles;
        let truckCount = vehicles.length;

        return (
            <div>
                <div className="mobileFont marginTop70 marginBottom10">
                    <h2 className="marginBottom10">Accident / Incident Reports</h2>

                    <span className="hidden">Truck Id: {this.state.truckId}</span>
                    <label className="input-group makeitflexspacebetween truckcheck-background" htmlFor="truckFilterId">
                        <span className="label-mobile--inline-sm margin5">Truck</span>
                        <select className="select margin5" id="vehicleId" name="vehicleId" value={this.state.truckId} onChange={(e) => this.handleTruckChange(e)} disabled={truckCount <= 1}>
                            <option hidden defaultValue="-1"></option>
                            {vehicles.map(truck =>
                                <option key={truck.id} value={truck.id}>{truck.name}</option>
                            )};
                        </select>
                    </label>

                </div>
                <div>
                    {driverTabsMobile}
                </div>
            </div>
        );

    }
}
